export const COOKIE_KEY_ID = 'id-token';
export const COOKIE_KEY_ACCESS = 'access-token';
